import React from 'react';
import { Card, EmptyState } from '../components/ui';

export default function Unauthorized() {
    return (
        <Card>
            <EmptyState>
                <i className="bx bx-lock-alt" />
                <h3>Accès refusé</h3>
                <p>Vous n'avez pas les permissions nécessaires pour consulter cette page.</p>
            </EmptyState>
        </Card>
    );
}
